<template>
<div class="cfLogs pt-20">
  <h5 class="text-center fw-500">Cloudflare Request Filtering</h5>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-end">
      <button @click="viewModal({}, 'addCFRequestFiltering')" class="btn btn-primary btn-sm">Add CF Request Filtering</button>
    </div>
  </div>
  <table id="datatable" class="table table-bordered">
    <thead>
    <th>Email</th>
    <th class="text-center">Plan</th>
    <th class="text-center">Date</th>
    <th class="text-center">Action</th>
    </thead>
    <tbody>
    <tr v-for="(row, index) of modifiedCFLogs" :key="index">
      <td>{{row.email}}</td>
      <td class="text-center">{{row.plan}}</td>
      <td class="text-center">{{formatDate(row.createdAt)}}</td>
      <td class="text-center">
        <button @click="viewModal(row, 'viewModal')" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
      </td>
    </tr>
    </tbody>
  </table>

</div>
</template>
<script>
import {db} from "@/firebase/init";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  name: 'cfLogs',
  components: {Multiselect},
  data() {
    return {
      loading: false,
      cfLogs: [],
      listener: null
    }
  },
  computed: {
    modifiedCFLogs () {
      return this.cfLogs.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      });
    }
  },
  watch: {
    cfLogs (val) {
      if(val.length) {
        // this.renderDatatable()
      }
    }
  },
  mounted() {
    this.load()
  },
  beforeDestroy() {
    if(this.listener){
      this.listener()
    }
  },
  methods: {
    renderDatatable() {
      console.log('rendering')
      if($.fn.DataTable.isDataTable( '#datatable' )) {
        $("#datatable").DataTable().destroy();
      }
      $("#datatable").DataTable({
        ordering: false,
        retrieve: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          emptyTable: "No data exists",
          size: '40'
        }
      });
    },
    updateModalData(id) {
      const obj = this.cfLogs.find((item) => item.id === id);
      this.$emit('onViewModal', {...obj, action: 'update'})
    },
    formatDate(date) {
      return moment(date).format('DD MMM, YYYY hh:mm A')
    },
    viewModal(data, type) {
      console.log('opening')
      data.type = type
      this.$emit('onViewModal', data)
    },
    load () {
      this.loading = false;
      let upQuery = null;
      upQuery = db.collection('cfLogs')
      this.listener = upQuery.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          switch (change.type) {
            case 'added':{
              const test= {id: change.doc.id , ...change.doc.data()}
              this.cfLogs.push(test);
              break;}
            case "modified":
            {
              console.log('modifying')
              const data = {id: change.doc.id, ...change.doc.data()}
              let taskToUpdate = this.cfLogs.find((task) => task.id === data.id );
              const allKeys = Object.keys(data);
              for (const key of allKeys){
                taskToUpdate[key] = data[key];
              }
            }
              break;
            case "removed":
            {
              const removedData = change.doc.data();
              this.cfLogs = this.cfLogs.filter(test => test.id !== removedData.id);
            }
              break;
          }
        });
      });
      this.loading = true;
    },
  }
}
</script>
<style scoped>

</style>